import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/xiazai.png'


const _withScopeId = n => (_pushScopeId("data-v-39cb5507"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = {
  key: 0,
  class: "matchstyle",
  id: "scrtop"
}
const _hoisted_3 = { class: "matchstyle-title" }
const _hoisted_4 = { class: "macebteb" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "macebteb-box-top flexcenter" }
const _hoisted_7 = { class: "macebteb-box-top-right" }
const _hoisted_8 = { class: "teamname" }
const _hoisted_9 = { class: "macebteb-box-top-left" }
const _hoisted_10 = { class: "macebteb-box-top-left-cen" }
const _hoisted_11 = {
  class: "vantimg",
  alt: ""
}
const _hoisted_12 = { class: "awayname" }
const _hoisted_13 = { class: "macebteb-box-top-left-cen" }
const _hoisted_14 = {
  class: "vantimg",
  alt: ""
}
const _hoisted_15 = { class: "awayname" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "APP下载", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "macebteb-box-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", null, "红8直播"),
  /*#__PURE__*/_createElementVNode("div", null, "官方直播")
], -1))

import { encryptionMatch } from "@/api/home";
import { ref, onMounted } from "vue";
import Loading from "@/components/Loading.vue";
import { Match } from "@/model/Match";
import dayjs from "dayjs";
import { Toast } from "vant";

const __default__ = {
  name: "MatchIndex",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["updara"],
  setup(__props, { emit }) {



onMounted(() => {
  getData();
});

let loading = ref(true);
let todaytime = ref("");
const loadingdata = ref(false);
const isLoading = ref(false);
const finished = ref(false);
let data = ref([]);

let state = ref({
  matchactive: 1, // 1 足球，2 篮球
  upPage: 0, // 下拉刷新的page
  downPage: 1, // 正常加载的page
  daytype: 1, // 1 正常加载，2 下拉刷新
  limit: 200, // 条数
});

const sersen = (item) => {
  let statusColor = "#0D0D0D";
  let status = Match.getStatus(item);
  if (item.host.length > 0 && status !== "完场") {
    status = "视频直播";
    statusColor = "#ED3C2F";
  }
  // if (status == "直播中") {
  //   statusColor = "#ED3C2F";
  // }
  if (item.status !== 8) {
    let timestamp = item.match_time * 1000;
    let time = dayjs(timestamp).format("HH:mm");
    status = `${time}`;
  }
  return { statusColor, status };
};

const getData = async () => {
  console.log("====>");

  isLoading.value = true;
  //时间，往前三个小时
  let time = Date.now();
  time = time - 1000 * 60 * 60 * 3;
  let times = time.toString();
  times = times.substring(0, times.length - 3);

  // 页码
  let page =
    state.value.daytype == 1 ? state.value.downPage : state.value.upPage;

  const res: any = await encryptionMatch({
    type_id: state.value.matchactive, // 1 足球，2 篮球  0全部，3热门
    day_type: state.value.daytype, // 1 正常加载，2 下拉刷新
    page: page, // 页码
    limit: 200, // 条数
    check_time: times, // 时间
  });
  if (res.code == 200) {
    if (data.value.length == 0) {
      data.value = res.data;
    } else {
      for (let i in res.data) {
        data.value.push(res.data[i]);
      }
    }
    // 排序
    if (data.value.length > 0) {
      data.value.sort((x, y) => {
        return x.match_time - y.match_time;
      });
    }
    daytime(data.value);
    loading.value = false;
    loadingdata.value = false;
    isLoading.value = false;
    state.value.limit = 20;
    // 获取数据等于空时
    if (data.value.length == 0) {
      finished.value = true;
    } else {
      finished.value = false;
    }
  }
};
const daytime = (data) => {
  if (data.length > 0) {
    const timestamp = data[0].match_time * 1000;
    let titleId = "activity";
    const day = dayjs(timestamp).format("MM月DD日");
    const dddd = getWeek(timestamp);
    const datatime = new Date();
    const datatimeyy = datatime.getFullYear();
    const datatimemm = datatime.getMonth() + 1;
    const datatimedd = datatime.getDate();
    const calendar = new Date(timestamp);
    const calendaryy = calendar.getFullYear();
    const calendarmm = calendar.getMonth() + 1;
    const calendardd = calendar.getDate();

    if (
      datatimeyy == calendaryy &&
      datatimemm == calendarmm &&
      datatimedd == calendardd
    ) {
      todaytime.value = `今天 ${day} ${dddd}`;
      titleId = "nowActivity";
    } else if (
      datatimeyy == calendaryy &&
      datatimemm == calendarmm &&
      datatimedd != calendardd
    ) {
      if (calendardd - datatimedd == 1) {
        todaytime.value = `明天 ${day} ${dddd}`;
      } else {
        todaytime.value = `${day} ${dddd}`;
      }
    } else {
      todaytime.value = `${day} ${dddd}`;
    }
  } else {
    todaytime.value = "";
  }
};
const getWeek = (data) => {
  let week = "";
  const time = new Date(data);
  if (time.getDay() == 0) week = "星期日";
  if (time.getDay() == 1) week = "星期一";
  if (time.getDay() == 2) week = "星期二";
  if (time.getDay() == 3) week = "星期三";
  if (time.getDay() == 4) week = "星期四";
  if (time.getDay() == 5) week = "星期五";
  if (time.getDay() == 6) week = "星期六";
  return week;
};
const tabchange = (type) => {
  //   tab改变时
  data.value = [];
  loading.value = true;
  isLoading.value = true;
  state.value.limit = 20;
  state.value.downPage = 1;
  state.value.upPage = 0;
  state.value.daytype = 1;
  state.value.matchactive = type;
  getData();
};

// 返回今天
const scrollInto = () => {
  data.value = [];
  state.value.limit = 20;
  state.value.downPage = 1;
  state.value.upPage = 0;
  state.value.daytype = 1;
  loading.value = true;
  getData();
};

const toh5page = (val) => {
  // window.open("https://m.h8tv.tv");
  if (val.id && val.type_id) {
    // window.open(
    //   "https://m.h8tv.tv?match_id=" +
    //     val.id +
    //     "&match_type=" +
    //     val.type_id +
    //     "&ax=12&to=room"
    // );
    window.open(
      "https://m.h8tv.tv?match_id=3684676&match_type=2&ax=12&to=room"
    );
  } else {
    Toast.fail("数据出错！");
  }
};
//  app下载
const uoadn = () => {
  emit("updara");
};

return (_ctx: any,_cache: any) => {
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_sticky, { "offset-top": 60 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (tabchange(0))),
            style: _normalizeStyle(
          _unref(state).matchactive == 0
            ? 'border: 1px solid  #FA0707; font-size: 14px; color: #FA0707;'
            : 'font-size: 12px;'
        )
          }, " 全部 ", 4),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tabchange(3))),
            style: _normalizeStyle(
          _unref(state).matchactive == 3
            ? 'border: 1px solid  #FA0707; font-size: 14px; color: #FA0707;'
            : 'font-size: 12px;'
        )
          }, " 热门 ", 4),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (tabchange(1))),
            style: _normalizeStyle(
          _unref(state).matchactive == 1
            ? 'border: 1px solid  #FA0707; font-size: 14px; color: #FA0707;'
            : 'font-size: 12px;'
        )
          }, " 足球 ", 4),
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (tabchange(2))),
            style: _normalizeStyle(
          _unref(state).matchactive == 2
            ? 'border: 1px solid  #FA0707; font-size: 14px; color: #FA0707;'
            : 'font-size: 12px;'
        )
          }, " 篮球 ", 4)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(Loading, { loading: _unref(loading) }, null, 8, ["loading"]),
      (_unref(data).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_unref(todaytime)), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "macebteb-box",
                  key: index,
                  onClick: ($event: any) => (toh5page(item))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", {
                        class: "ovehide",
                        style: _normalizeStyle({
                  color:
                    item.status == 8 ? '#909090' : sersen(item).statusColor,
                })
                      }, _toDisplayString(sersen(item).status), 5),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(item.competition_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
                            [_directive_lazy, item.home_log]
                          ]),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(item.home_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
                            [_directive_lazy, item.away_log]
                          ]),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(item.away_name), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "iconText",
                        onClick: [
                          _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                          _cache[5] || (_cache[5] = ($event: any) => (uoadn()))
                        ]
                      }, _hoisted_18)
                    ])
                  ]),
                  _hoisted_19
                ], 8, _hoisted_5))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})